import {
  DATE_MASK,
  UNDERDASH,
  SEPARATOR,
  DATE_PARTS_COUNT,
  YEAR_INDEX,
  YEAR_STR_LENGTH,
  DAY_AND_MONTH_STR_LENGTH,
} from './config'

const createMaskedDate = (data: string[] | null | undefined) => {
  try {
    // Добивает недостающие части массива даты пустыми значениями

    while (data && data.length < DATE_PARTS_COUNT) {
      data.push('')
    }
    // Если год длиннее максимально возможной длины - обрезаем

    if (data && data[YEAR_INDEX]?.length > YEAR_STR_LENGTH) {
      data[YEAR_INDEX] = data[YEAR_INDEX].slice(0, YEAR_STR_LENGTH)
    }

    const maskedDate =
      data
        ?.map((number, index) => {
          // Разное поведение для года и для остальных частей даты
          if (index !== YEAR_INDEX) {
            return (
              number +
              UNDERDASH.repeat(DAY_AND_MONTH_STR_LENGTH - number.length)
            )
          } else {
            return number + UNDERDASH.repeat(YEAR_STR_LENGTH - number.length)
          }
        })
        ?.join(SEPARATOR) ?? DATE_MASK

    return maskedDate
  } catch (error) {
    console.log(error)
  }
}

export default createMaskedDate
